import { en } from "./en.ts";

export const t = en;
const locale = "en";
const plurals = new Intl.PluralRules(locale);

/** Replaces {name}-style placeholders. */
export function fmt(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => String(values[key] ?? ""));
}

/** Picks the plural form for `n` and fills it; `{n}` is always available. */
export function fmtCount(
  forms: { one: string; other: string },
  n: number,
  values: Record<string, string | number> = {},
): string {
  const form = plurals.select(n) === "one" ? forms.one : forms.other;
  return fmt(form, { n, ...values });
}
